/** @constant {string} portalName - Name of the portal 
* @memberof Utils 
*/
export const portalName = 'e-Operations';
/**
 * @constant {string[]} singlePhaseLabels - Labels for single-phase readings
 * @memberof Utils
 */
export const singlePhaseLabels = ['Previous Reading', 'Reading', 'Units Charged']
/**
 * @constant {string[]} threePhaseLabels - Labels for three-phase readings
* @memberof Utils
 */
export const threePhaseLabels = ['Off Peak Reading (Previous)', 'Reading - Off Peak', 'Peak Reading (Previous)', 'Reading - Peak']

/**
 * @constant {string[]} netMeterLabels - Labels for net metering readings
* @memberof Utils
 */
export const netMeterLabels = ['Off Peak Import Reading (Previous)', 'Off Peak Import Reading (Current)', 'Peak Import Reading (Previous)', 'Peak Import Reading (Current)', 'Off Peak Export Reading (Previous)', 'Off Peak Export Reading (Current)', 'Peak Export Reading (Previous)', 'Peak Export Reading (Current)']

/** 
 * @memberof Utils
 */
export const singlePhaseCurrentLabels = ['Claimed Reading']
/** 
 * @memberof Utils
 */
export const threePhaseCurrentLabels = ['Off Peak Reading', 'Peak Reading']
/** 
 * @memberof Utils
 */
export const threePhaseUnitsChargedLabels = ['Off Peak Units Charged (kWh)', 'Peak Units Charged (kWh)']
/** 
 * @memberof Utils
 */
export const netMeterCurrentLabels = ['Off Peak Import Reading', 'Peak Import Reading', 'Off Peak Export Reading', 'Peak Export Reading']
/** 
 * @memberof Utils
 */
export const netMeterUnitsChargedLabels = ['Off Peak Import Units Charged (kWh)', 'Peak Import Units Charged (kWh)', 'Off Peak Export Units Charged (kWh)', 'Peak Export Units Charged (kWh)']
/** 
 * @memberof Utils
 */
export const singlePhaseClaimedLabels = ['Difference']
/** 
 * @memberof Utils
 */
export const threePhaseClaimedLabels = ['Off Peak Units', 'Peak Units']
/** 
 * @memberof Utils
 */
export const netMeterClaimedLabels = ['Off Peak Import Units', 'Peak Import Units', 'Off Peak Export Units', 'Peak Export Units']

/** 
 * @memberof Utils
 */
export const threePhaseClaimedImagesLabels = ['Off Peak', 'Peak']
/** 
 * @memberof Utils
 */
export const netMeterClaimedImagesLabels = ['Off Peak Import', 'Peak Import', 'Off Peak Export', 'Peak Export']


/** @memberof Utils 
 * @constant {Object.<number, string>} companyNameTitle 
 * @description Mapping of company IDs to their respective names.
 */
export const companyNameTitle = {
    11: 'Lahore Electric Supply Company',
    12: 'Gujranwala Electric Power Company',
    13: 'Faisalabad Electric Supply Company',
    14: 'Islamabad Electric Supply Company',
    15: 'Multan Electric Power Company',
    16: 'Peshawar Electric Supply Company',
    27: 'Sukkur Electric Power Company',
    37: 'Hyderabad Electric Supply Company',
    48: 'Quetta Electric Supply Company',
    59: 'Tribal Area Electric Supply Company'
}
/** 
 * @memberof Utils 
 * @constant {RegExp} passwordRegex 
 * @description Regular expression for validating strong passwords.
 */
export const passwordRegex = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&#])[A-Za-z\d@$!%*?&#]{8,}$/;
/** 
 * @memberof Utils
 */
export const defaultServices = [
    "New Connections",
    // "Meter Reading Corrections",
    "Bill Installments",
    "Due Date Extensions",
    // "Meter Change Requests",
    "Change of Name",
    "Change of Load",
    "Change of Tariff",
];
/** @memberof Utils 
 * @constant {string[]} defaultServices 
 * @description List of default services provided.
 */
export const defaultServicesCFC = [
    "New Connections",
    // "Meter Reading Corrections",
    "Bill Installments",
    "Due Date Extensions",
    // "Meter Change Requests",
    "Change of Attributes",
];
/** 
 * @memberof Utils
 */
export const defaultDurations = ["Progressive", "Monthly", "CurrentMonth", "Daily"];
/** 
 * @memberof Utils
 */
export const defaultDurationsFieldOffice = ["Progressive", "CurrentMonth", "Daily"];

/** 
 * @memberof Utils
 */
export const otherComplaintsArray = [{
    code: 8,
    name: 'Phase Issue'
}, {
    code: 9,
    name: 'Additional Feeder'
}, {
    code: 10,
    name: 'Damaged Transformer - Rural'
}, {
    code: 11,
    name: 'Damaged Transformer - Urban'
}, {
    code: 12,
    name: 'Transformer Relocation/Augmentation'
}, {
    code: 13,
    name: 'Additional Transformer'
}, {
    code: 14,
    name: 'Live Fallen Wire'
}, {
    code: 15,
    name: 'Service Line Reloc/Improve - Short Term'
}, {
    code: 16,
    name: 'LT/HT Line Relocation/Improvement- Long Term'
}, {
    code: 17,
    name: 'Meter Sparking/Wire Loose'
}, {
    code: 18,
    name: 'Permanent Rectification of Temporary Fix'
},
{
    code: 19,
    name: 'Tripping (Due to Transformer)'
}

]


export const otherComplaintsArrayCommerical = [
    { code: 27, name: 'Vehicle Theft', resolutionTime: '4 hrs' },
    { code: 28, name: 'Violation of Energy Conservation Measures', resolutionTime: '2 hrs' },
    { code: 29, name: 'Electrical Safety', resolutionTime: '48 hrs' },
    { code: 30, name: 'Defective Meter (1-phase)', resolutionTime: '10 days' },
    { code: 31, name: 'Defective Meter (3-phase)', resolutionTime: '15 days' },
    { code: 32, name: 'Wrong Meter Reading', resolutionTime: '72 hrs' },
    { code: 33, name: 'No Meter Reading Taken', resolutionTime: '72 hrs' },
    { code: 34, name: 'Excess Billing', resolutionTime: '72 hrs' },
    { code: 35, name: 'Under Billing', resolutionTime: '72 hrs' },
    { code: 36, name: 'Account Information', resolutionTime: '72 hrs' },
    { code: 37, name: 'Bribery/Corruption', resolutionTime: '7 days' },
    { code: 38, name: 'Delayed Meter Reading', resolutionTime: '72 hrs' },
    { code: 39, name: 'Additional Transformer', resolutionTime: '4 days' },
    { code: 40, name: 'Temporary Connection', resolutionTime: '7 days' },
    { code: 41, name: 'Relocation of Meter', resolutionTime: '7 days' },
    { code: 42, name: 'New Connection', resolutionTime: '7 days' },
    { code: 43, name: 'Reconnection', resolutionTime: '7 days' },
    { code: 44, name: 'Change of Sanctioned Load', resolutionTime: '7 days' },
    { code: 45, name: 'Electrification', resolutionTime: '14 days' },
    { code: 46, name: 'Loadshedding Schedule', resolutionTime: '9 days' },
    { code: 47, name: 'Change of Tariff', resolutionTime: '9 days' },
    { code: 48, name: 'Replacement Distribution Box', resolutionTime: '9 days' },
    { code: 49, name: 'Change of Name', resolutionTime: '45 days' },
    { code: 50, name: 'Transformer Oil Leakage', resolutionTime: '8 hrs' },
    { code: 51, name: 'Leakage of current', resolutionTime: '1 hrs' },
    { code: 52, name: 'Net Metering', resolutionTime: '48 hrs' }
]
/** 
 * @memberof Utils
 */
export const powerOutage = 1;
/** 
 * @memberof Utils
 */
export const damagedMeter = 2;
/** 
 * @memberof Utils
 */
export const fluctuation = 4;
/** 
 * @memberof Utils
 */
export const electricFire = 3;
/** 
 * @memberof Utils
 */
export const lineFault = 5;
/** 
 * @memberof Utils
 */
export const others = 1000;
/** 
 * @memberof Utils
 */
export const lowVoltageShortTerm = 6;
/** 
 * @memberof Utils
 */
export const lowVoltageLongTerm = 7;
/** 
 * @memberof Utils
 */
export const phaseIssue = 8;
/** 
 * @memberof Utils
 */
export const liveFallenWire = 14;
/** 
 * @memberof Utils
 */
export const delayedNoMeterReading = 33;
/** 
 * @memberof Utils
 */
export const firstBillNotReceived = 22;
/** 
 * @memberof Utils
 */
export const unjustifiedDetectionBill = 21;
/** 
 * @memberof Utils
 */
export const unjustifiedLPS = 99;
/** 
 * @memberof Utils
 */
export const MeterPosition = 20;
export const DetectionBill = 21;
export const DelayedBillingNewConnection = 22;
export const  NonDeliveryofBill = 23;
export const ElectricityTheft = 24;
export const InstalledTransformerMeterWireTheft = 25;
export const BulkDistributionTheft = 26;


/** @memberof Utils 
 * @constant {string} imageExtensions 
 * @description Allowed image file extensions.
 */
export const imageExtensions = ".png, .jpg, .jpeg"
/** @memberof Utils 
 * @constant {string} documentExtensions 
 * @description Allowed document file extensions.
 */
export const documentExtensions = ".png, .jpg, .jpeg, .pdf"